import { ICountries, IStates } from '../sharedTypes';

export const parseCountryData = (data: ICountries[]) => {
  return data
    .map((country: ICountries) => ({
      ...country,
      label: country.name
        .toLowerCase()
        .split(' ')
        .map((word: string) => {
          if (word !== 'and' && word !== 'of') {
            return word.charAt(0) === '('
              ? word[0] + word[1].toUpperCase() + word.slice(2)
              : word[0].toUpperCase() + word.slice(1);
          } else {
            return word;
          }
        })
        .join(' '),
      states: country.states.map((state: IStates) => ({
        ...state,
        label: state.name
      }))
    }))
    .sort((a: ICountries, b: ICountries) => {
      return a.name.localeCompare(b.name);
    }) as ICountries[];
};
